import Vue from 'vue'
export default {
  namespaced: true,
  state: {
    carts: [],
    csr: {}
  },
  getters: {
    cartsCnt: state => state.carts.length,
    totalQty: state => state.carts.reduce((sum, c) => sum + c.qty, 0)
  },
  mutations: {
    add (state, item) {
      const index = state.carts.findIndex(c => c.id === item.id)
      if (index === -1) {
        state.carts.push({
          id: item.id,
          name: item.name,
          code: item.code,
          qty: item.qty
        })
      } else {
        const info = state.carts[index]
        info.qty += item.qty
        Vue.set(state.carts, index.info)
      }
    },
    delete (state, id) {
      let index = state.carts.findIndex(i => i.id === id)
      if (index !== -1) {
        state.carts.splice(index, 1)
      }
    },
    clear (state) {
      state.carts.splice(0)
    },
    addCsr (state, customer) {
      state.csr = customer
    }
  },
  actions: {
    addToCart (context, item) {
      context.commit('add', item)
      context.dispatch('saveToLocal')
    },
    deleteFromCart (context, id) {
      context.commit('delete', id)
      context.dispatch('saveToLocal')
    },
    saveCsr (context, csr = {}) {
      context.commit('addCsr', csr)
      context.dispatch('saveToLocal')
    },
    clearCart (context) {
      context.commit('clear')
      context.commit('addCsr', {})
      context.dispatch('saveToLocal')
    },
    saveToLocal (context) {
      localStorage.setItem('carts', JSON.stringify(context.state.carts))
      localStorage.setItem('carts_csr', JSON.stringify(context.state.csr))
    },
    restore ({ commit }) {
      const carts = JSON.parse(localStorage.getItem('carts')) || []
      const csr = JSON.parse(localStorage.getItem('carts_csr')) || {}
      carts.forEach(c => commit('add', c))
      commit('addCsr', csr)
    }
  }
}
